import get from 'lodash/get';
import { connect } from 'react-redux';

import { fetchMediaSetRequirements } from '../../../media-set-requirements/actions';
import RequirementsGuide from './RequirementsGuide';

export default connect(
  ({ mediaSetRequirements, products }, { productId }) => {
    const relatedProduct = products.find(p => p.id === productId);
    return {
      mediaSetRequirements: mediaSetRequirements.filter(
        requirement => requirement.productId === productId,
      ),
      requirements: get(relatedProduct, 'creativeRequirements', []),
    };
  },
  {
    fetchMediaSetRequirements,
  },
)(RequirementsGuide);
